export default __webpack_public_path__ + "static/media/RW.bb156feb.svg";